export default __webpack_public_path__ + "static/media/M1F.b75c465c.jpg";